// javascript
export class DateHandler {
    init() {
        let self = this;

        /** Handle manual start date change */
        $(document).on('change', '#startDate', function () {
            self.checkDateChange();
        });

        $(document).on('keyup', '#startDate', function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                self.checkDateChange();
            }
        });

        /** Handle quantity change */
        $(document).on('change', '#quantity_wanted', function () {
            self.checkDateChangeQty();
            self.changeTotalPrice();
        });

        $(document).on('click', '.js-quantity-button .btn', function () {
            self.checkDateBtnChangeQty();
            self.changeTotalPrice();
        });

        // Handle datepicker unfocus
        $(document).on('unblur', '#startDate', function () {
            self.checkDateUnblur();
        });

        // Initialization
        this.initDatepicker();
    }

    changeTotalPrice() {
        let totalPrice = $('.total-price-location').data('price-unit');
        let newTotalPrice = (totalPrice * parseInt($('#quantity_wanted').val(), 10)).toFixed(2);
        $('.total-price-location').text(newTotalPrice.replace('.', ',') + ' €');
    }

    /**
     * Compute the earliest selectable date:
     * - default shippingDelay = 1
     * - if current hour >= 15, add one more day to the delay
     * - if today is Friday, earliest selectable is next Tuesday
     * Returns a Date at 00:00 of the first selectable day.
     */
    // javascript
    getMinSelectableDate() {
        let now = new Date();
        now.setDate(now.getDate());
        let currentDay = now.getDay();
        let currentHour = now.getHours();
        let shippingDelayDays = 0;
        if (currentDay > 0 && currentDay < 4) { // Monday to Wednesday, add 1 day + 1 if current hour >= 15
            shippingDelayDays = currentHour >= 15 ? 2 : 1;
        }

        switch (currentDay) {
            case 4: // Thursday
                shippingDelayDays = currentHour < 15 ? 1 : 4; // If it's before 3pm, the earliest is next Friday, else next Monday
                break;
            case 5: // Friday
                shippingDelayDays = currentHour < 15 ? 3 : 4; // If it's before 3pm, the earliest is next Monday, else next Tuesday
                break;
            case 6: // Saturday
                shippingDelayDays = 3;
                break;
            case 0: // Sunday
                shippingDelayDays = 2;
                break;
        }
        let deliveryDate = new Date(now);
        deliveryDate.setDate(deliveryDate.getDate() + shippingDelayDays);
        return deliveryDate;
    }

    checkDateChange(selector = '#startDate', endSelector = '#endDateContainer span.text-danger', qtySelector = $('#quantity_wanted')) {
        let val = $(selector).val();
        let self = this;
        let parsed = self.parseDateFromString(val);
        let minSelectable = self.getMinSelectableDate();

        if (!val || val.trim() == '' || !self.isADate(val) || !parsed || parsed.getTime() < minSelectable.getTime() || self.isWeekend(parsed)) {
            // Find and select the first available date (non-weekend, non-blocked) starting from minSelectable
            let firstAvailableDate = self.findFirstAvailableDate();
            if (firstAvailableDate) {
                $(selector).val(self.formatDateToString(firstAvailableDate));
                $(selector).change();
                self.calculateEndDate(selector, endSelector, qtySelector);
                if ($('.custom-add-to-cart').length) self.activeButton('.custom-add-to-cart');
                return true;
            } else {
                $(selector).val('');
                $(endSelector).text(chooseDate);
                if ($('.custom-add-to-cart').length) self.disableButton('.custom-add-to-cart');
                return false;
            }
        } else {
            if ($('.custom-add-to-cart').length) self.activeButton('.custom-add-to-cart');
            return true;
        }
    }

    /** Find the first available date (non-weekend, non-blocked) starting from computed minimum selectable date */
    findFirstAvailableDate() {
        let currentDate = this.getMinSelectableDate();
        currentDate.setHours(0, 0, 0, 0);

        // Search up to 365 days in the future
        for (let i = 0; i < 365; i++) {
            let testDate = new Date(currentDate);
            testDate.setDate(currentDate.getDate() + i);

            // Check weekend
            if (this.isWeekend(testDate)) {
                continue;
            }

            // Check blocked dates
            if (typeof blockedDates !== 'undefined' && Array.isArray(blockedDates)) {
                let isBlocked = false;
                for (let blockedDateStr of blockedDates) {
                    let blockedDate = this.parseDateFromString(blockedDateStr);
                    if (blockedDate && blockedDate.getTime() === testDate.getTime()) {
                        isBlocked = true;
                        break;
                    }
                }
                if (isBlocked) continue;
            } else if ($(selector).data('blockeddates') != '') { // Blocked Dates per product
                let blockedDatesStr = $(selector).data('blockeddates');
                let blockedDatesArray = blockedDatesStr.split(',');
                let isBlocked = false;

                for (let blockedDatesStr of blockedDatesArray) {
                    let blockedDate = this.parseDateFromString(blockedDateStr);
                    if (blockedDate && blockedDate.getTime() === testDate.getTime()) {
                        isBlocked = true;
                        break;
                    }
                }
                if (isBlocked) continue;
            }

            // Available date found
            return testDate;
        }

        return null; // No available date found
    }

    checkDateUnblur(selector = '#startDate', endSelector = '#endDateContainer span.text-danger') {
        let startDate = $(selector).val();
        let self = this;

        if (!startDate || startDate.trim() == '' || !self.parseDateFromString(startDate)) {
            $(endSelector).text(chooseDate);
            if ($('.custom-add-to-cart').length) self.disableButton('.custom-add-to-cart');
        } else {
            if ($('.custom-add-to-cart').length) self.activeButton('.custom-add-to-cart');
        }
    }

    checkDateBtnChangeQty(selector = '#startDate', endSelector = '#endDateContainer span.text-danger', qtySelector = $('#quantity_wanted')) {
        let startDate = $(selector).val();
        let self = this;

        if (self.parseDateFromString(startDate) != null && startDate != '' && self.parseDateFromString(startDate)) {
            self.calculateEndDate(selector, endSelector, qtySelector);
            if ($('.custom-add-to-cart').length) self.activeButton('.custom-add-to-cart');
        } else {
            $(endSelector).text(chooseDate);
            if ($('.custom-add-to-cart').length) self.disableButton('.custom-add-to-cart');
        }
    }

    checkDateChangeQty(selector = '#startDate', endSelector = '#endDateContainer span.text-danger') {
        let startDate = $(selector).val();
        let self = this;

        if (self.parseDateFromString(startDate) != null && startDate != '' && self.parseDateFromString(startDate)) {
            self.calculateEndDate(selector, endSelector, $('#quantity_wanted'));
            if ($('.custom-add-to-cart').length) self.activeButton('.custom-add-to-cart');
        } else {
            $(endSelector).text(chooseDate);
            if ($('.custom-add-to-cart').length) self.disableButton('.custom-add-to-cart');
        }
    }

    disableButton(selector) {
        $(selector).attr('disabled', 'disabled');
    }

    activeButton(selector) {
        $(selector).removeAttr('disabled');
    }

    /** Check if a date is a weekend */
    isWeekend(date) {
        let day = date.getDay();
        return day === 0 || day === 6; // 0 = Sunday, 6 = Saturday
    }

    isADate(date) {
        // If the date is not in the dd/mm/yyyy format
        if (!/^\d{2}\/\d{2}\/\d{2,4}$/.test(date)) {
            return false;
        }
        return true;
    }

    /** Convert 'dd/mm/yy' or 'dd/mm/yyyy' string to Date object */
    parseDateFromString(dateStr) {
        if (!dateStr) return null;
        let parts = dateStr.split('/');
        if (parts.length < 3) return null;
        let day = parseInt(parts[0], 10);
        let month = parseInt(parts[1], 10) - 1;
        let year = parts[2];
        // If year is 'yy', assume 2000+
        if (year.length === 2) {
            year = 2000 + parseInt(year, 10);
        } else {
            year = parseInt(year, 10);
        }
        return new Date(year, month, day);
    }

    /** Format a Date to 'dd/mm/yyyy' */
    formatDateToString(date) {
        let day = String(date.getDate()).padStart(2, '0');
        let month = String(date.getMonth() + 1).padStart(2, '0');
        let year = String(date.getFullYear());
        return `${day}/${month}/${year}`;
    }

    /** Add weeks to a date (counts calendar days) */
    addWeeksToDate(startDate, weeks) {
        let endDate = new Date(startDate);
        endDate.setDate(endDate.getDate() + (weeks * 7));
        return endDate;
    }

    /** Calculate and display the end date */
    // qtySelector is a jQuery object to allow dynamic quantity retrieval on the cart page
    calculateEndDate(selector, endSelector, qtySelector) {
        let startDateStr = $(selector).val();
        let quantity = parseInt(qtySelector.val(), 10) || 1;

        if (!startDateStr) {
            return;
        }

        let start = this.parseDateFromString(startDateStr);
        if (!start) {
            return;
        }

        let endDate = this.addWeeksToDate(start, quantity);
        let options = {year: 'numeric', month: 'long', day: 'numeric'};
        let formattedDate = endDate.toLocaleDateString('fr-FR', options);

        $(endSelector).text(formattedDate);
        try {
            $(selector).datepicker('refresh');
        } catch (e) {
        }
    }

    /** Determine if a date can be selected */
    beforeShowDay(date, selector, qtySelector) {
        if (!date) return;
        date.setHours(0, 0, 0, 0);
        let classes = '';
        let tooltip = '';
        let selectable = true;

        // Check minimum selectable date (shipping delay + rules)
        let minSelectable = this.getMinSelectableDate();
        minSelectable.setHours(0, 0, 0, 0);

        // Block dates before minSelectable
        if (date.getTime() < minSelectable.getTime()) {
            classes += classes ? ' ui-datepicker-unselectable' : 'ui-datepicker-unselectable';
            selectable = false;
            tooltip = Unavailable;
        }

        // Always block today's date explicitly
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        if (date.getTime() === today.getTime()) {
            classes += classes ? ' ui-datepicker-unselectable' : 'ui-datepicker-unselectable';
            selectable = false;
            tooltip = Unavailable;
        }

        // Check if date is in the selected period
        let startDateStr = $(selector).val();
        if (startDateStr) {
            let start = this.parseDateFromString(startDateStr);
            let quantity = parseInt(qtySelector.val(), 10) || 1;
            let endDate = this.addWeeksToDate(start, quantity);

            if (start && date >= start && date <= endDate) {
                classes += classes ? ' ui-datepicker-highlighted' : 'ui-datepicker-highlighted';
                tooltip = IncludedHighlighted;
            }
        }

        // Weekends handling
        if (this.isWeekend(date)) {
            classes += classes ? ' ui-datepicker-weekend' : 'ui-datepicker-weekend';
            selectable = false;
            tooltip = classes.includes('ui-datepicker-highlighted')
                ? UnavailableHighlighted
                : Unavailable;
        }

        if (blockedDates != undefined && Array.isArray(blockedDates) && blockedDates.length > 0) {
            $.each(blockedDates, (index, blockedDateStr) => {
                let blockedDate = this.parseDateFromString(blockedDateStr);
                if (blockedDate.getTime() === date.getTime()) {
                    classes += classes ? ' ui-datepicker-unselectable' : 'ui-datepicker-unselectable';
                    selectable = false;
                    tooltip = classes.includes('ui-datepicker-highlighted')
                        ? UnavailableHighlighted
                        : Unavailable;
                }
            });
        }

        // Blocked Dates per product
        if ($(selector).data('blockeddates') != '') {
            let blockedDatesStr = $(selector).data('blockeddates');
            let blockedDatesArray = blockedDatesStr.split(',');

            $.each(blockedDatesArray, (index, blockedDateStr) => {
                let parsedBlockedDate = this.parseDateFromString(blockedDateStr);
                if (parsedBlockedDate.getTime() === date.getTime()) {
                    classes += classes ? ' ui-datepicker-unselectable' : 'ui-datepicker-unselectable';
                    selectable = false;
                    tooltip = classes.includes('ui-datepicker-highlighted')
                        ? UnavailableHighlighted
                        : Unavailable;
                }
            });
        }

        if (tooltip == '') tooltip = Available;

        return [selectable, classes, tooltip];
    }

    /** Initialize jQuery UI datepicker */
    initDatepicker(selector = '#startDate', endSelector = '#endDateContainer span.text-danger', btnSelector = '.custom-add-to-cart', qtySelector = $('#quantity_wanted')) {
        let self = this;

        $(selector).attr('type', 'text');
        if ($(selector).hasClass('hasDatepicker')) {
            try {
                $(selector).datepicker('destroy');
            } catch (e) {
            }
        }

        $(selector).datepicker({
            dateFormat: 'dd/mm/yy',
            // Use computed minimum selectable date
            minDate: self.getMinSelectableDate(),
            maxDate: '+1y',
            firstDay: 1,
            changeMonth: true,
            changeYear: true,
            beforeShowDay: function (date) {
                return self.beforeShowDay(date, selector, qtySelector);
            },
            showOn: 'focus',
            onSelect: function () {
                self.calculateEndDate(selector, endSelector, qtySelector);
                self.activeButton(btnSelector);
                $(this).focus();
                prestashop.emit('dateLocationChange');
            },
            dayNamesMin: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
            monthNames: [
                'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
                'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
            ],
            monthNamesShort: [
                'Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin',
                'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'
            ],
        });

        // Always reopen the calendar correctly
        $(selector).on('click focus', function (e) {
            e.stopPropagation();
            $(this).datepicker('show');
        });
    }

    initSurgeryDatepicker(selector) {
        let self = this;
        let selectedDate = null;

        $(selector).attr('type', 'text');
        if ($(selector).hasClass('hasDatepicker')) {
            try {
                $(selector).datepicker('destroy');
            } catch (e) {
            }
        }

        $(selector).datepicker({
            dateFormat: 'dd/mm/yy',
            minDate: 0,
            maxDate: '+1y',
            firstDay: 1,
            changeMonth: true,
            changeYear: true,
            beforeShowDay: function (date) {
                let classes = '';
                let selectable = true;

                // Highlight the selected date
                if (selectedDate && date.getTime() === selectedDate.getTime()) {
                    classes = 'ui-datepicker-highlighted';
                }

                return [selectable, classes, ''];
            },
            onSelect: function (dateText) {
                selectedDate = self.parseDateFromString(dateText);
                $(this).datepicker('refresh');
            },
            showOn: 'focus',
            dayNamesMin: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
            monthNames: [
                'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
                'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
            ],
            monthNamesShort: [
                'Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin',
                'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'
            ],
        });

        // Always reopen the calendar correctly
        $(selector).on('click focus', function (e) {
            e.stopPropagation();
            $(this).datepicker('show');
        });
    }
};
